import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["parentPlaylistId"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import getAssetType from 'utils/asset/getAssetType';
import { getTranslatedErrorMessage } from 'utils/i18n';
import api from 'utils/api';
import { setAlert } from 'actions/alerts';
function useCreateDraftAsset(_ref) {
  var parentPlaylistId = _ref.parentPlaylistId,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function createAsset(_x) {
    return _createAsset.apply(this, arguments);
  }
  function _createAsset() {
    _createAsset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(assetData) {
      var data;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return api('post', '/api/assets', null, [_objectSpread(_objectSpread(_objectSpread({}, assetData), getAssetType(assetData)), {}, {
              parentPlaylistId: parentPlaylistId
            })]);
          case 1:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _createAsset.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: createAsset
    }, options), {}, {
      onError: function onError(error, variables) {
        setAlert({
          title: variables.type ? t("alert_add_".concat(variables.type, "_error")) : t('alert_add_asset_error'),
          message: getTranslatedErrorMessage(error)
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    createDraftAsset: mutateAsync
  });
}
export default useCreateDraftAsset;